import { jsx, jsxs } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { useDeleteOrLeaveResource } from '../../../../resource-detail/hooks/useDeleteOrLeaveResource.js';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { isResourceDetailFolder } from '../../../utils/resourceDetailGuards.js';
import { IconTrash } from '@fabric-app/icons/svg';

const ContextItemDelete = () => {
  const { resource } = useResourceDataContextSafe();
  const { label: removeLabel, action: removeAction, disabledReason } = useDeleteOrLeaveResource();
  return /* @__PURE__ */ jsx(ContextMenu.Group, {
    children: /* @__PURE__ */ jsxs(ContextMenu.Item, {
      onSelect: removeAction,
      "data-testid": "item-context-menu-delete-button",
      variant: "danger",
      disabledReason,
      children: [
        /* @__PURE__ */ jsx(DropdownItemIconContainer, {
          children: /* @__PURE__ */ jsx(IconTrash, {})
        }),
        removeLabel,
        " ",
        isResourceDetailFolder(resource) && "folder"
      ]
    })
  });
};

export { ContextItemDelete };
//# sourceMappingURL=ContextItemDelete.js.map
